// The three states a catalog license can be in, as the Licenses board's
// Status column, its pills and the license panel say them. One word each,
// written for the operator: Live is sold and set up; Needs setup means an
// operator still has to say which product it is for and how its quantities
// count seats (until then the Fenerum import skips its subscriptions, so the
// row shows no customers and no MRR — not an empty license, an unknown one);
// Deprecated is being retired, with a migration worklist on the panel.
export const LICENSE_PLAN_STATUS = {
  Live: "Live",
  NeedsSetup: "Needs setup",
  Deprecated: "Deprecated",
} as const

export type LicensePlanStatus =
  (typeof LICENSE_PLAN_STATUS)[keyof typeof LICENSE_PLAN_STATUS]

// What the Product cell and filter say when no product is declared yet.
export const LICENSE_PLAN_NO_PRODUCT = "No product"
